var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-popover',_vm._g({},_vm.$listeners),[_vm._t("default"),_c('template',{slot:"reference"},[_vm._t("reference")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }